import { render, staticRenderFns } from "./RedeemCodeList.vue?vue&type=template&id=006ddc9b&"
import script from "./RedeemCodeList.vue?vue&type=script&lang=js&"
export * from "./RedeemCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports